import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Grid,
  Typography,
} from '@material-ui/core';

import useStyles from './styles';

function Header({ className, reportDate, ...rest }) {
  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.rootHeader, className)}
      container
      justifyContent="space-between"
      spacing={3}
      alignItems="center"
      {...rest}
    >
      <Grid item xs={12} md={7}>
        <Typography
          variant="h3"
          color="textPrimary"
        >
          Estado scrapers
        </Typography>
        {reportDate && (
          <Typography
            variant="subtitle1"
            color="textSecondary"
          >
            {reportDate}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  reportDate: PropTypes.string,
};

Header.defaultProps = {
  className: null,
  reportDate: null,
};

export default Header;
